<div>
    <h4>Edit Credit Card</h4>
    <div class="row mt-4">
        <h5 class="col-md-4">Editing information for card ending in {{card.lastFourDigits}}</h5>
    </div>
    <div class="row">
        <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
    </div><br>

    <div class="row">
        <form class="col-8" [formGroup]="editCardForm" (ngSubmit)="submit()">
            <div class="row">
                <div class="mb-3 col-md-4">
                    <label for="firstName" class="required">First Name</label>
                    <input class="form-control" appScrText formControlName="firstName" id="firstName" placeholder="First Name"
                    maxlength="{{MaxLen.FirstName}}" autocomplete="cc-given-name"
                    [ngClass]="{'error-input': editCardForm.get('firstName')!.invalid && submitted === true}"/>
                    <ng-container *ngIf="editCardForm.get('firstName')!.invalid && submitted === true">
                        <span *ngIf="editCardForm.get('firstName')!.errors?.required" class="failed"> First Name is required.</span>
                        <span *ngIf="editCardForm.get('firstName')!.errors?.appFirstNameValidator" class="failed">First Name has an invalid format.</span>
                    </ng-container>
                </div>
                <div class="mb-3 col-md-4">
                    <label for="lastName" class="required">Last Name</label>
                    <input class="form-control" appScrText formControlName="lastName" id="lastName" placeholder="Last Name" 
                    maxlength="{{MaxLen.LastName}}" autocomplete="cc-family-name"
                    [ngClass]="{'error-input': editCardForm.get('lastName')!.invalid && submitted === true}"/>
                    <ng-container *ngIf="editCardForm.get('lastName')!.invalid && submitted === true">
                        <span *ngIf="editCardForm.get('lastName')!.errors?.required" class="failed"> Last Name is required.</span>
                        <span *ngIf="editCardForm.get('lastName')!.errors?.appLastNameValidator" class="failed">Last Name has an invalid format.</span>

                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-4">
                    <label for="country" class="required">Country</label>
                    <p-dropdown appDd #country [styleClass]="editCardForm.get('country')!.invalid && submitted ? 'field-errors' : ''"  
                        [options]="countries" [filter]="true" id="country" autocomplete="billing country-name"
                        optionLabel="countryName" optionValue="country"  (onChange)="getRegions($event.value, true)" 
                        formControlName="country" placeholder="Country" >
                    </p-dropdown>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-12">
                    <label for="address1" class="required">Street Address 1</label>
                    <input class="form-control" appScrText formControlName="address1" placeholder="Street Address" id="address1"
                    maxlength="{{MaxLen.Address}}" autocomplete="billing address-line1"
                        [ngClass]="{'error-input': editCardForm.get('address1')!.invalid && submitted === true}"/>
                    <ng-container *ngIf="editCardForm.get('address1')!.invalid && submitted === true">
                        <span *ngIf="editCardForm.get('address1')!.errors?.required" class="failed">Street Address 1 is required.</span>
                    </ng-container>
                </div>
            </div> 
            <div class="row">
                <div class="mb-3 col-md-12">
                    <label for="address2">Street Address 2</label>
                    <input class="form-control" appScrText formControlName="address2" id="address2" placeholder="Street Address 2" 
                    autocomplete="billing address-line2" maxlength="{{MaxLen.Address}}"/>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-4">
                    <label for="city" class="required">City</label>
                    <input class="form-control" appScrText formControlName="city" id="city" placeholder="City" maxlength="{{MaxLen.City}}"
                        autocomplete="billing address-level2"
                        [ngClass]="{'error-input': editCardForm.get('city')!.invalid && submitted === true}"/>  
                    <ng-container *ngIf="editCardForm.get('city')!.invalid && submitted === true">
                        <span *ngIf="editCardForm.get('city')!.errors?.required" class="failed">City is required.</span>
                    </ng-container>               
                </div>
                <div class="mb-3 col-md-4">
                    <label for="state" [ngClass]="{'required': editCardForm.get('country')?.value === 'us' ||
                        editCardForm.get('country')?.value === 'ca'}">State/Province </label>
                    <p-dropdown appDd #state [styleClass]="editCardForm.get('state')!.invalid && submitted ? 'field-errors ' : ''" 
                        [options]="regionList" [filter]="true" id="state" autocomplete="billing address-level1"
                        optionLabel="regionName" optionValue="region" [disabled]="regionList.length === 0"
                        formControlName="state" [placeholder]="regionList.length > 0 ? 'Select' : 'Not Available'">
                    </p-dropdown>
                    <ng-container *ngIf="editCardForm.get('state')!.invalid && submitted === true">
                        <span *ngIf="editCardForm.get('state')!.errors?.required" class="failed">State/Province is required.</span>
                    </ng-container>     
                </div>
                <div class="mb-3 col-md-4">
                    <label for="zip" [ngClass]="{'required': editCardForm.get('country')?.value === 'us' ||
                    editCardForm.get('country')?.value === 'ca'}">Zip/Postal Code </label>
                    <input class="form-control" *ngIf="editCardForm.get('country')?.value === 'us'" appScrText mask="00000||00000-0000" formControlName="zip" id="zip"
                        placeholder="Zip/Postal Code" [dropSpecialCharacters]="false" maxlength="{{MaxLen.Zip}}" [validation]="true"
                        [ngClass]="{'error-input': editCardForm.get('zip')!.invalid && submitted === true}"/>
                    <input class="form-control" *ngIf="editCardForm.get('country')?.value !== 'us'" appScrText [mask]="dynamicMask" formControlName="zip" id="zip"
                        placeholder="Zip/Postal Code" [dropSpecialCharacters]="false" maxlength="{{MaxLen.Zip}}"
                         appZip [country]="editCardForm.get('country')?.value"
                        [ngClass]="{'error-input': editCardForm.get('zip')!.invalid && submitted === true}"/>
                    <ng-container *ngIf="editCardForm.get('zip')!.invalid && submitted === true && editCardForm.get('country')?.value === 'us'">
                        <span *ngIf="editCardForm.get('zip')!.errors?.required" class="failed">Zip/Postal Code is required.</span>
                    </ng-container>
                    <ng-container *ngIf="editCardForm.get('zip')!.invalid && submitted === true && editCardForm.get('country')?.value === 'ca'">
                        <span *ngIf="editCardForm.get('zip')!.errors?.required" class="failed">Zip/Postal Code is required.</span>
                    </ng-container>
                    <ng-container *ngIf="(editCardForm.get('zip')!.errors?.invalid || editCardForm.get('zip')!.errors?.mask) && submitted === true && editCardForm.get('country')?.value === 'ca'" >
                        <span class="failed">Zip/Postal Code is invalid. (example: A1A 1A1)</span>
                    </ng-container>
                    <ng-container *ngIf="(editCardForm.get('zip')!.errors?.invalid || editCardForm.get('zip')!.errors?.mask) && submitted === true && editCardForm.get('country')?.value === 'us'" >
                        <span class="failed">Zip/Postal Code is invalid. (example: 99999 or 99999-9999)</span>
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h5 id="expirationDate" class="m-0">Expiration Date</h5>
                </div>
            </div>
            <div class="row mt-2" id="cardTypeLib">
                <div class="mb-3 col-md-2">
                    <label for="expirationMonth" class="required">Month</label>
                    <p-dropdown appDd [styleClass]="(editCardForm.errors?.cardExpiration || editCardForm.get('expirationMonth')!.invalid) && submitted ? 
                        'field-errors ' : ''" [filter]="true" id="expirationMonth" autocomplete="cc-exp-month"
                        [options]="months" formControlName="expirationMonth" placeholder="Month">
                    </p-dropdown>
                    <ng-container *ngIf="editCardForm.get('expirationMonth')!.invalid && submitted === true">
                        <span *ngIf="editCardForm.get('expirationMonth')!.errors?.required" class="failed">Month is required.</span>
                    </ng-container> 
                </div>
                <div class="mb-3 col-md-2">
                    <label for="expirationYear" class="required">Year</label>
                    <p-dropdown appDd [styleClass]="(editCardForm.errors?.cardExpiration || editCardForm.get('expirationYear')!.invalid) && submitted ? 
                        'field-errors ' : ''" [options]="years" [filter]="true" id="expirationYear" autocomplete="cc-exp-year"
                        formControlName="expirationYear" placeholder="Year">
                </p-dropdown>
                <ng-container *ngIf="editCardForm.get('expirationYear')!.invalid && submitted === true">
                    <span *ngIf="editCardForm.get('expirationYear')!.errors?.required" class="failed">Year is required.</span>
                </ng-container> 
                </div>
            </div>
            <ng-container *ngIf="editCardForm.errors?.cardExpiration && submitted === true">
                <div class="failed" style="margin-bottom: .5em;">The credit card you are attempting to use has expired.</div>
            </ng-container>
            <div class="row">
                <div class="mb-3 col-md-7">
                    <label for="description">Description</label>
                    <input class="form-control" appScrText id="description" formControlName="description" placeholder="Description" maxlength="30"/>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-8">
                    <p-checkbox class="p-formcontrol" label="Set as default" id="default" [binary]="true" value="false" formControlName="default"></p-checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col small ms-4">
                    Setting this as the default payment method indicates that this payment method will be used for auto-renew.
                </div>
            </div>
            <div class="d-flex justify-content-start ps-3 mt-3">
                <button class="btn btn-primary me-3" submit>Update Payment Method</button>
                <button class="btn btn-secondary" type="button" (click)="confirmCancelDialog()">Cancel</button>
            </div>
            <p-confirmDialog key='confirmCancel' #creditFormCancel width="425" [closable]="false">
                <p-footer>
                    <div class="d-flex justify-content-end">
                        <button i18n id="scaccept" class="btn btn-primary me-2" type="button" (click)="creditFormCancel.accept()">Yes</button>
                        <button i18n id="screject" class="btn btn-secondary" type="button" (click)="creditFormCancel.reject()">No</button>
                    </div>
                </p-footer>
            </p-confirmDialog>
        </form>
    </div>
</div>
